import { ConfigProvider } from 'antd';
import React from 'react';

export default function ThemeConfig({ children }) {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#3fb350', // working
          colorSecondary: '#937fbb',
          fontFamily: 'Poppins'
        },
      }}
    >
      {children}
    </ConfigProvider>
  );
}
